import fb from '@/services/firebase.js'

export const namespaced = true

export const state = {
  details: null,
  loading: false,
  regions: null,
  pricing: null
}

export const mutations = {
  SET_DETAILS(state, details) {
    state.details = details
  },
  SET_LOADING(state, value) {
    state.loading = value
  },
  SET_REGION(state, value) {
    state.regions = value
  },
  SET_PRICING(state, value) {
    state.pricing = value
  }
}

export const actions = {
  getOrderArrangements({ commit }, id) {
    commit('SET_LOADING', true)
    fb.db
      .collection('orders')
      .doc(id)
      .onSnapshot(doc => {
        commit('SET_DETAILS', doc.data())
      })
  },
  submitOrderArrangements({ commit }, details) {
    commit('SET_LOADING', true)
    var id = details.id
    delete details.id
    fb.db
      .collection('orders')
      .doc(id)
      .update(details)
      .then(() => {
        return true
      })
  },
  readRegions({ commit }) {
    commit('SET_LOADING', true)
    fb.db.collection('regions').onSnapshot(docs => {
      var regions = []
      docs.forEach(doc => {
        var state_details = doc.data()
        state_details.doc_id = doc.id
        regions.push(state_details)
      })
      commit('SET_REGION', regions)
    })
  },
  getPricing({ commit }) {
    commit('SET_PRICING', null)
    var data = []
    fb.db
      .collection('price')
      .get()
      .then(docs => {
        docs.forEach(doc => {
          var current = doc.data()
          current.doc_id = doc.id
          data.push(current)
        })
        commit('SET_PRICING', data)
      })
  }
}

export const getters = {
  getClosestDistance: state => details => {
    var closestCompany = []
    //var initial = 1000000000 //twice the length of the largest city in africa.
    state.regions.forEach(region => {
      region.region.forEach(payload => {
        // eslint-disable-next-line no-undef
        var d = google.maps.geometry.spherical.computeDistanceBetween(
          // eslint-disable-next-line no-undef
          new google.maps.LatLng(details.lat, details.lng),
          // eslint-disable-next-line no-undef
          new google.maps.LatLng(payload.coordinates.lat, payload.coordinates.lng)
        )
        if (d <= 10000) {
          var value = payload
          value.state = region.doc_id
          state.pricing.forEach(price => {
            if (price.doc_id == region.doc_id) {
              value.cost = price
            }
          })
          closestCompany.push(payload)
        } else {
          var value2 = payload
          value2.state = region.doc_id
          state.pricing.forEach(price => {
            if (price.doc_id == region.doc_id) {
              value2.cost = price
            }
          })
          closestCompany.push(payload)
        }
      })
    })
    return closestCompany
  }
}
